import { VALIDATION_MESSAGES } from "utils/constants";
import * as Yup from "yup";

export const ValidationSchema = Yup.object({
  old_password: Yup.string().required(
    VALIDATION_MESSAGES.PROFILE.PASSWORD.CHANGE.REQUIRED_CURRENT_PASSWORD
  ),
  password: Yup.string()
    .required(VALIDATION_MESSAGES.PROFILE.PASSWORD.CHANGE.REQUIRED_NEW_PASSWORD)
    .matches(
      /^(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/,
      "Password must be minimum of 8 characters, alphanumeric and contain at least one special character"
    )
    .test(
      "no-match",
      "New password must be different than old password",
      (value, { parent }) => value !== parent.old_password
    ),
  confirm_password: Yup.string()
    .oneOf(
      [Yup.ref("password"), null],
      VALIDATION_MESSAGES.PROFILE.PASSWORD.INVALID_CONFIRM_PASSWORD
    )
    .required(VALIDATION_MESSAGES.PROFILE.PASSWORD.CONFIRM_PASSWORD),
});
